import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorAirdrop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="m3.994 11.3-.003.002.002-.002Zm4.51-.004a2.426 2.426 0 0 0-.129-.157 3.325 3.325 0 0 0-.452-.42c-.4-.307-.962-.594-1.673-.594-.711 0-1.273.287-1.673.595a3.324 3.324 0 0 0-.583.58l-.003.002a.75.75 0 0 1-1.235-.85v-.002l.002-.001.002-.003.005-.007.015-.021a3.96 3.96 0 0 1 .224-.276c.15-.168.37-.39.658-.612.576-.442 1.451-.905 2.588-.905s2.012.463 2.588.905c.105.081.2.162.287.24.087-.078.183-.159.287-.24.576-.442 1.451-.905 2.588-.905s2.012.463 2.588.905c.092.071.177.142.255.211.07-.065.145-.132.227-.198.573-.466 1.454-.918 2.68-.918 1.226 0 2.107.452 2.68.918a3.935 3.935 0 0 1 .786.86l.044.072.014.024.005.01.002.003.001.001s0 .002-.657.362l.658-.36a.75.75 0 0 1-1.312.727m-.003-.006v.002l.002.002v.002a1.656 1.656 0 0 0-.099-.141 2.437 2.437 0 0 0-.386-.394c-.35-.284-.907-.582-1.735-.582-.828 0-1.384.298-1.735.582a2.442 2.442 0 0 0-.47.51l-.015.024m4.438-.003v-.002.002Zm-5.71.064-.002-.003a2.431 2.431 0 0 0-.13-.16 3.323 3.323 0 0 0-.452-.42c-.4-.307-.963-.594-1.674-.594s-1.273.287-1.673.595a3.328 3.328 0 0 0-.58.576.741.741 0 0 1-.306.26.745.745 0 0 1-.846-.15.74.74 0 0 1-.091-.11"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M4.134 10.54C4.326 6.818 7.713 3.75 12 3.75c4.287 0 7.674 3.067 7.866 6.79l-6.018 5.234 1.848-4.62a.75.75 0 1 0-1.392-.558L12 16.356l-2.304-5.76a.75.75 0 0 0-1.392.557l1.848 4.621-6.018-5.233Zm-1.264.89.016.014 8.62 7.495.01.01a.75.75 0 0 0 .976-.008l8.625-7.5a.747.747 0 0 0 .258-.572m0 0C21.371 6.045 17.11 2.25 12 2.25c-5.112 0-9.375 3.799-9.375 8.625a.747.747 0 0 0 .245.554"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M8.625 19.5a1.5 1.5 0 0 1 1.5-1.5h3.75a1.5 1.5 0 0 1 1.5 1.5v2.25a1.5 1.5 0 0 1-1.5 1.5h-3.75a1.5 1.5 0 0 1-1.5-1.5V19.5ZM20.25.75l.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
    />
  </svg>
);
export default SvgTwoColorAirdrop;
